module.exports = __webpack_public_path__ + "static/media/Sharp-LS013B7DD02-Technical-Drawing.fd84c923.jpg";